import Axios from "axios";
import { Notify } from "notiflix/build/notiflix-notify-aio";

import { English } from "../Language/Messages/English";
import { Portuguese } from "../Language/Messages/Portuguese";

const userKey = "loginToken";

const helper = {

  SocketBackendURL: function () {
    return "https://apiricojogos.osiztech.com/";
  },
  FrontBackendURL: function () {
    return "https://apiricojogos.osiztech.com/user";
  },

  WithdrawAPI: function () {
    return "https://api.sandbox.hopysplit.com.br/v1/transfers";
  },

  GoogleClientID: function () {
    return "1045050258447-jgdduvaq2cjt2vo764medf4hcik8j8a8.apps.googleusercontent.com";
  },
  FaceBoolClientID: function () {
    return "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";
  },

  PostData: async function (url, data, type) {
    let params;
    params = data;

    let axiosConfig;
    let userKey = localStorage.getItem("loginToken");
    if (userKey != "") {
      if (type === "formData") {
        axiosConfig = {
          headers: {
            "Content-Type": "multipart/form-data",
            "Access-Control-Allow-Origin": "false",
            "x-access-token": userKey,
          },
        };
      } else {
        axiosConfig = {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            "Access-Control-Allow-Origin": "false",
            "x-access-token": userKey,
          },
        };
      }
    } else {
      axiosConfig = {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          "Access-Control-Allow-Origin": "false",
        },
      };
    }

    return await Axios.post(url, params, axiosConfig)
      .then((res) => {
        let output = res?.data;
        try {
          if (output?.status === 200 || output?.status == true) {
            if (output?.status) {
              if (output?.message || output?.Message) {
                console.log('output?.message: ', output?.message);

                if (localStorage.getItem('lang') === 'en') {
                  English.map((temp, index) => {
                    if (temp?.Key === output?.key) {
                      Notify.success(temp?.message, {
                        theme: "colored",
                        showOnlyTheLastOne: true,
                        clickToClose: true,
                        timeout: 1500,
                        position: "center-top"
                      });
                    }
                  })
                }
                else {
                  Portuguese.map((temp, index) => {
                    if (temp?.Key === output?.key) {
                      Notify.success(temp?.message, {
                        theme: "colored",
                        showOnlyTheLastOne: true,
                        clickToClose: true,
                        timeout: 1500,
                        position: "center-top"
                      });
                    }
                  })
                }
              }
            } else {
              if (output.message == "Unauthorized") {

                if (localStorage.getItem('lang') === 'en') {
                  Notify.failure("You session have timed out !", {
                    theme: "colored",
                    showOnlyTheLastOne: true,
                    clickToClose: true,
                    timeout: 1500,
                    position: "center-top"
                  });

                  localStorage.removeItem(userKey);

                  window.location.href = "/";
                }
                else {
                  Notify.failure("Sua sessão expirou !", {
                    theme: "colored",
                    showOnlyTheLastOne: true,
                    clickToClose: true,
                    timeout: 1500,
                    position: "center-top"
                  });

                  localStorage.removeItem(userKey);

                  window.location.href = "/";
                }
              } else {
                if (output.message || output.Message) {
                  if (localStorage.getItem('lang') === 'en') {
                    English.map((temp, index) => {
                      if (temp?.Key === output?.key) {
                        Notify.failure(temp?.message, {
                          theme: "colored",
                          showOnlyTheLastOne: true,
                          clickToClose: true,
                          timeout: 1500,
                          position: "center-top"
                        });
                      }
                    })
                  }
                  else {
                    Portuguese.map((temp, index) => {
                      if (temp?.Key === output?.key) {
                        Notify.failure(temp?.message, {
                          theme: "colored",
                          showOnlyTheLastOne: true,
                          clickToClose: true,
                          timeout: 1500,
                          position: "center-top"
                        });
                      }
                    })
                  }
                }
              }
            }
            return res;
          } else {
            if (output?.message === "No Records Found") {
              return res;
            }
            else if (output?.message) {
              if (localStorage.getItem('lang') === 'en') {
                English.map((temp, index) => {
                  if (temp?.Key === output?.key) {
                    Notify.failure(temp?.message, {
                      theme: "colored",
                      showOnlyTheLastOne: true,
                      clickToClose: true,
                      timeout: 1500,
                      position: "center-top"
                    });
                  }
                })
              }
              else {
                Portuguese.map((temp, index) => {
                  if (temp?.Key === output?.key) {
                    Notify.failure(temp?.message, {
                      theme: "colored",
                      showOnlyTheLastOne: true,
                      clickToClose: true,
                      timeout: 1500,
                      position: "center-top"
                    });
                  }
                })
              }

            }
            return res;
          }
        } catch (e) {
          if (localStorage.getItem('lang') === 'en') {
            Notify.failure("Internal Server failure !", {
              showOnlyTheLastOne: true,
              clickToClose: true,
              timeout: 1500,
              position: "center-top"
            });
          }
          else {
            Notify.failure("Falha interna do servidor !", {
              showOnlyTheLastOne: true,
              clickToClose: true,
              timeout: 1500,
              position: "center-top"
            });
          }
        }
      })
      .catch((e) => {
        if (localStorage.getItem('lang') === 'en') {
          Notify.failure("Internal Server failure !", {
            showOnlyTheLastOne: true,
            clickToClose: true,
            timeout: 1500,
            position: "center-top"
          });
        }
        else {
          Notify.failure("Falha interna do servidor !", {
            showOnlyTheLastOne: true,
            clickToClose: true,
            timeout: 1500,
            position: "center-top"
          });
        }
      });
  },

  GetData: async function (url) {
    let axiosConfig;
    let userKey = localStorage.getItem("loginToken");
    if (userKey != "") {
      axiosConfig = {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          "Access-Control-Allow-Origin": "false",
          "x-access-token": userKey,
        },
      };
    } else {
      axiosConfig = {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          "Access-Control-Allow-Origin": "false",
        },
      };
    }

    return Axios.get(url, axiosConfig)
      .then((res) => {
        let output = res?.data;

        if (output?.status === 200 || output?.status == true) {
          return res;
        } else {
          if (output?.message === "No Records Found") {
            return res;
          }
          else if (output?.message) {
            if (localStorage.getItem('lang') === 'en') {
              English.map((temp, index) => {
                if (temp?.Key === output?.key) {
                  Notify.failure(temp?.message, {
                    theme: "colored",
                    showOnlyTheLastOne: true,
                    clickToClose: true,
                    timeout: 1500,
                    position: "center-top"
                  });
                }
              })
            }
            else {
              Portuguese.map((temp, index) => {
                if (temp?.Key === output?.key) {
                  Notify.failure(temp?.message, {
                    theme: "colored",
                    showOnlyTheLastOne: true,
                    clickToClose: true,
                    timeout: 1500,
                    position: "center-top"
                  });
                }
              })
            }

          }
        }
      })
      .catch((e) => {
        try {
          if (e.response.status === 401) {
            window.location.href = "/";
          } else {
            return { status: false, message: e };
          }
        } catch (e) {
          return { status: false, message: "Something went wrong" };
        }
      });
  },

  formatDated1: function (date) {
    date = new Date(date);
    var hours = date.getHours();
    var minutes = date.getMinutes();
    var seconds = date.getSeconds();
    var dates = date.getDate();
    var months = date.getMonth() + 1;
    var years = date.getFullYear();
    var ampm = hours >= 12 ? "PM" : "AM";
    hours = hours % 12;
    hours = hours ? hours : 12;
    hours = hours < 10 ? "0" + hours : hours;
    minutes = minutes < 10 ? "0" + minutes : minutes;
    seconds = seconds < 10 ? "0" + seconds : seconds;
    dates = dates < 10 ? "0" + dates : dates;
    months = months < 10 ? "0" + months : months;
    var strTime = hours + ":" + minutes + ":" + seconds + " " + ampm;
    // return years + "-" + months + "-" + dates;
    return dates + "/" + months + "/" + years + " " + strTime;
  },

  formatDated: function (date) {
    date = new Date(date);
    var hours = date.getHours();
    var minutes = date.getMinutes();
    var seconds = date.getSeconds();
    var dates = date.getDate();
    var months = date.getMonth() + 1;
    var years = date.getFullYear();
    var ampm = hours >= 12 ? "PM" : "AM";
    hours = hours % 12;
    hours = hours ? hours : 12;
    hours = hours < 10 ? "0" + hours : hours;
    minutes = minutes < 10 ? "0" + minutes : minutes;
    seconds = seconds < 10 ? "0" + seconds : seconds;
    dates = dates < 10 ? "0" + dates : dates;
    months = months < 10 ? "0" + months : months;
    var strTime = hours + ":" + minutes + ":" + seconds + " " + ampm;
    return dates + "/" + months + "/" + years + " " + strTime;
  },


  roundValues: function (num, precision) {
    if (typeof num != undefined && typeof num != "undefined") {
      if (num) {
        if (num.toString().indexOf("e") > -1) {
          num = parseFloat(num).toFixed(precision);
        }
        var num1 = num.toString().split(".");
        var num2 = num1[0];
        if (num1.length === 2) {
          num2 = num2 + "." + num1[1].substring(0, precision);
        }
        return parseFloat(num2).toFixed(precision);
      } else {
        return (0).toFixed(precision);
      }
    } else {
      return num;
    }
  },
};

export default helper;
